
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#ffffff",
        "d": "M826.986667 800.405333v64h-597.333334v-64h597.333334z m-298.666667-629.333333a170.666667 170.666667 0 0 1 131.52 279.424l-3.754667 4.373333 0.042667 0.021334a85.013333 85.013333 0 0 0-21.12 56.234666c0 26.197333 11.797333 49.664 30.378667 65.301334l140.266666-0.021334a64 64 0 0 1 64 64v64a64 64 0 0 1-64 64h-554.666666a64 64 0 0 1-64-64v-64a64 64 0 0 1 64-64h143.04a85.12 85.12 0 0 0 28.906666-64c0-21.333333-7.829333-40.853333-20.778666-55.808A170.666667 170.666667 0 0 1 528.32 171.093333z m86.570667 445.802667l-2.090667-2.133334a150.336 150.336 0 0 1-21.482667-28.352 148.672 148.672 0 0 1-20.330666-75.264c0-37.546667 13.866667-71.872 36.736-98.112a106.666667 106.666667 0 1 0-160.341334-1.792l2.410667 2.645334-0.533333-0.576h0.042666l0.512 0.597333 1.216 1.365333-0.042666 0.021334 2.346666 2.752a148.714667 148.714667 0 0 1 33.6 94.378666 148.650667 148.650667 0 0 1-39.296 100.949334 150.165333 150.165333 0 0 1-27.797333 23.722666l-5.312 3.349334-163.541333-0.021334v64h554.666666v-64H645.546667a149.76 149.76 0 0 1-22.272-15.786666l-5.077334-4.544-1.493333-1.450667-0.981333-0.917333-0.256-0.256-0.469334-0.448 0.469334 0.448-0.576-0.576z"
      }
    }
  ]
})
    }
  